// extracted by mini-css-extract-plugin
export default {"root":"_2dwfH","small":"_2HcLZ","normal":"_3ezoA"};